import Main from '@/views/administracion/infraestructura/Main.vue';
import Default from '@/views/administracion/infraestructura/Default.vue';
import Configuracion from './configuracion';

// auth y scopes de planeacion
const auth = ['Planeación:ver'];
const scopes = ['Planeación:crear', 'Planeación:editar', 'Planeación:eliminar'];

const infraestructura = [
  {
    path: 'infraestructura',
    meta: {
      title: '',
      auth,
    },
    component: Main,
    children: [
      ...Configuracion,
      {
        name: 'infraestructura',
        path: '/',
        meta: {
          title: 'Infraestructura',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
    ],
  },
];

export default infraestructura;
